<template>
  <section class="testimonials-section">
    <div class="testimonials-wrapper">
      <div class="testimonials-left">
        <div class="testimonials-header">
            <div class="satisfaction-stats">
              <div class="avatars-group">
                <img :src="require('@/assets/img/002b8a4b4e0821f28ae15b7ef30f11f6deddfc35.jpg')" alt="User">
                <img :src="require('@/assets/img/30650b209440c13d938f9ce6173aa32ebb5af340.jpg')" alt="User">
                <img :src="require('@/assets/img/7b9311647c674c9463b2ddf02d941db92f62f6d9.jpg')" alt="User">
              </div>
              <div class="stats-text">
                <strong>88% Satisfaction</strong>
                <div class="rating">
                  <i class="bi bi-star-fill"></i>
                  <span>Avis très positif</span>
                </div>
              </div>
            </div>
            <h2 class="testimonials-title">Les avis de nos utilisateurs</h2>
            <p class="testimonials-subtitle">Nolido, la finance partout, pour tous</p>
            <div class="carousel-controls">
              <button class="control-btn" @click="previousTestimonial">
                <i class="bi bi-arrow-left"></i>
              </button>
              <button class="control-btn control-btn-active" @click="nextTestimonial">
                <i class="bi bi-arrow-right"></i>
              </button>
            </div>
        </div>
      </div>
      <div class="testimonials-right" ref="carouselContainer">
        <div class="testimonials-carousel">
          <div class="testimonial-card" v-for="(testimonial, index) in testimonials" :key="index">
            <div class="card-content">
              <div class="flags">
                <img :src="testimonial.flag1" :alt="testimonial.country1" class="flag-icon">
                <img :src="testimonial.flag2" :alt="testimonial.country2" class="flag-icon">
              </div>
              <p class="testimonial-text">"{{ testimonial.text }}"</p>
              <div class="testimonial-author">
                <strong>{{ testimonial.name }}</strong>, {{ testimonial.location }}
              </div>
            </div>
            <div>
              <CustomButton
                label="Télécharger l'App"
                @click="handleDownload"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue';

export default {
  name: "TestimonialsSection",
  components: {
    CustomButton
  },
  data() {
    return {
      testimonials: [
        {
          flag1: "https://flagcdn.com/w80/fr.png",
          flag2: "https://flagcdn.com/w80/sn.png",
          country1: "France",
          country2: "Sénégal",
          text: "J'utilise Nolido depuis plus de 5 ans pour transférer des fonds chaque mois depuis la France vers le Sénégal. Je recommande Nolido à d'autres expatriés.",
          name: "Fatou Diagne",
          location: "France"
        },
        {
          flag1: "https://flagcdn.com/w80/bf.png",
          flag2: "https://flagcdn.com/w80/bj.png",
          country1: "Burkina Faso",
          country2: "Bénin",
          text: "C'était si rapide pour envoyer de l'argent au Burkina Faso depuis le Bénin.",
          name: "Prince Tossou",
          location: "Bénin"
        },
        {
          flag1: "https://flagcdn.com/w80/ci.png",
          flag2: "https://flagcdn.com/w80/ml.png",
          country1: "Côte d'Ivoire",
          country2: "Mali",
          text: "Service excellent et rapide ! Je peux envoyer de l'argent à ma famille au Mali en quelques secondes.",
          name: "Aminata Traoré",
          location: "Côte d'Ivoire"
        }
      ]
    };
  },
  methods: {
    scrollToNext() {
      const container = this.$refs.carouselContainer;
      const cardWidth = 400 + 32; // largeur de la carte + gap
      container.scrollBy({
        left: cardWidth,
        behavior: 'smooth'
      });
    },
    scrollToPrevious() {
      const container = this.$refs.carouselContainer;
      const cardWidth = 400 + 32; // largeur de la carte + gap
      container.scrollBy({
        left: -cardWidth,
        behavior: 'smooth'
      });
    },
    nextTestimonial() {
      this.scrollToNext();
    },
    previousTestimonial() {
      this.scrollToPrevious();
    },
    handleDownload() {
      window.open('#', '_blank');
    }
  }
};
</script>

<style scoped>
.testimonials-section {
  background: #FAFAFA;
  padding: 80px 0;
  position: relative;
  overflow: visible;
}

.testimonials-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 3rem;
  max-width: 1400px;
  margin: 0 auto;
  padding-left: 4rem;
  overflow: visible;
}

.testimonials-left {
  flex: 0 0 350px;
}


.testimonials-right {
  flex: 1;
  overflow-x: auto;
  overflow-y: visible;
  margin-right: calc(-100vw + 100%);
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scroll-snap-type: x mandatory;
  scroll-padding-left: 0;
}

.testimonials-right::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.testimonials-header {
  padding: 2rem 0;
}

.satisfaction-stats {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.avatars-group {
  display: flex;
  margin-right: 0;
}

.avatars-group img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid white;
  margin-left: -12px;
  object-fit: cover;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.avatars-group img:first-child {
  margin-left: 0;
}

.stats-text {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.stats-text strong {
  font-size: 0.95rem;
  color: #1A1A1A;
  font-weight: 600;
}

.rating {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.85rem;
  color: #666;
}

.rating i {
  color: #FFD700;
  font-size: 0.9rem;
}

.testimonials-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #1A1A1A;
  line-height: 1.15;
  margin-bottom: 1rem;
  letter-spacing: -0.03em;
}

.testimonials-subtitle {
  font-size: 1.05rem;
  color: #666;
  margin-bottom: 2rem;
  font-weight: 400;
}

.carousel-controls {
  display: flex;
  gap: 1rem;
}

.control-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: #FFF5E8;
  color: #1A1A1A;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
}

.control-btn:hover {
  background: #F5A847;
  color: white;
  transform: scale(1.05);
}

.control-btn-active {
  background: #F5A847;
  color: white;
}

.control-btn i {
  font-size: 1.2rem;
}

.testimonials-carousel {
  display: flex;
  gap: 2rem;
  padding: 2rem 0;
  overflow-x: visible;
}

.testimonial-card {
  background: #3D2F1F;
  border-radius: 24px;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 380px;
  min-width: 400px;
  max-width: 400px;
  flex-shrink: 0;
  transition: transform 0.3s, box-shadow 0.3s;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.testimonial-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.2);
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  flex: 1;
}

.flags {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.flag-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.testimonial-text {
  font-size: 1.05rem;
  color: white;
  line-height: 1.65;
  margin: 0;
  font-weight: 400;
  font-style: italic;
  flex: 1;
}

.testimonial-author {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.75);
  margin-top: auto;
}

.testimonial-author strong {
  color: white;
  font-weight: 600;
  display: block;
  margin-bottom: 0.2rem;
}

.card-footer {
  display: flex;
  justify-content: flex-start;
  margin-top: 1rem;
}

@media (max-width: 992px) {
  .testimonials-section {
    padding: 60px 0;
  }

  .testimonials-wrapper {
    flex-direction: column;
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .testimonials-left {
    flex: 1;
    width: 100%;
  }

  .testimonials-title {
    font-size: 2rem;
  }

  .testimonials-header {
    padding: 2rem 0;
    margin-bottom: 2rem;
  }

  .testimonials-carousel {
    grid-template-columns: 1fr;
    padding: 0;
  }
}

@media (max-width: 768px) {
  .testimonials-wrapper {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .testimonials-header {
    padding: 1rem 0;
    text-align: center;
  }

  .testimonials-title {
    font-size: 1.75rem;
  }

  .testimonials-subtitle {
    font-size: 0.95rem;
  }

  .satisfaction-stats {
    justify-content: center;
  }

  .carousel-controls {
    justify-content: center;
  }

  .testimonial-card {
    min-height: 320px;
    padding: 2rem;
  }

  .testimonials-carousel {
    grid-template-columns: 1fr;
  }
  
  .testimonial-text {
    font-size: 0.95rem;
  }
  
  .flag-icon {
    width: 28px;
    height: 28px;
  }
}
</style>
